import React from 'react';
import { MockService } from '../../../../../../types/rest/mockServiceTypes';
import SslConfiguration, { AssetAssignmentBundle, SSlConfigMode } from '../../SslConfiguration';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store/rootReducer';
import { isTemplate } from '../../../../../../utils/miscUtil';
import { updateMockServiceAssets } from '../../../../../../store/mockServices/mockServiceDetail/mockServiceDetailActions';

interface SslConfigProps {
  mockService: MockService;
  disabled: boolean;
}

const RunnerSslConfig = ({ mockService, disabled }: SslConfigProps) => {
  const dispatch = useDispatch();

  const assets = useSelector((state: ApplicationState) => {
    return !isTemplate(mockService) ? state.mockServiceDetails.assets : state.mockServiceTemplateDetail.assets;
  });

  const updateMockServiceAssetsHandler = (assetAssignment: AssetAssignmentBundle) => {
    if (!isTemplate(mockService)) {
      dispatch(updateMockServiceAssets(assetAssignment));
    } else {
      alert('Template');
    }
  };

  return (
    <SslConfiguration
      heading={<h4 className={'mb-4'}>SSL Authentication</h4>}
      assetsBundle={assets.assetBundle}
      disabled={disabled}
      configMode={SSlConfigMode.SERVER}
      onAssignmentChanged={updateMockServiceAssetsHandler}
    />
  );
};

export default RunnerSslConfig;
